// i18n keys of the multi-tenant work package "invoice" (invoice-audit follow-up, 2026-10-03): per-company fields the
// invoice paths print or send. ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  cs_name_th: 'Thai name (tax invoices)',
  cs_branch_no: 'Branch no. (00000 = head office)',
  cs_payment_notice: 'Notice on invoice emails',
  cs_payment_notice_hint: 'Shown at the top of this company’s invoice and payment-reminder emails, one line per line. Leave empty for none.',
};
export const zh: Record<string, string> = {
  cs_name_th: '泰文名称（税务发票）',
  cs_branch_no: '分支编号（00000 = 总公司）',
  cs_payment_notice: '发票邮件提示',
  cs_payment_notice_hint: '显示在本公司发票邮件和催款邮件的顶部，每行一句。留空则不显示。',
};
export const th: Record<string, string> = {
  cs_name_th: 'ชื่อภาษาไทย (ใบกำกับภาษี)',
  cs_branch_no: 'เลขที่สาขา (00000 = สำนักงานใหญ่)',
  cs_payment_notice: 'ข้อความแจ้งในอีเมลใบแจ้งหนี้',
  cs_payment_notice_hint: 'แสดงที่ด้านบนของอีเมลใบแจ้งหนี้และอีเมลเตือนชำระเงินของบริษัทนี้ บรรทัดละหนึ่งข้อความ เว้นว่างหากไม่ต้องการ',
};
